<template>
  <div class="inputValueSubscription" @click.stop>
    <CInput class="mb-0 inputValueSubscription__input d-flex" :value="numberWithCommas(item.balance)" :disabled="true">
      <template #append>
        <CButton
          v-if="!item.addOnOrganizationStatus || item.addOnOrganizationStatus == 1"
          data-cy="valueSubscritionEdit"
          class="tableBalance__btn"
          color="white"
          @click="toggleInputValue(item, index)"
        >
          <CIcon name="editFull" :height="10" viewBox="0 0 32 32" />
        </CButton>
      </template>
    </CInput>

    <div class="absolute-center" v-if="item._modalChangeValue || isActive" @click.stop>
      <transition name="fade">
        <div class="dataTable__popUp bg-white p-3 mb-3 shadow-sm">
          <div class="d-flex">
            <CInput
              data-cy="inputValueSubscrition"
              @click.stop
              class="addReduce__input pl-2"
              type="number"
              v-model="currentBalanceTemp"
              @keypress="isNumber($event)"
              :placeholder="$t(`backoffice.manage.balance.tables.components.input.placeholder.value`)"
            />
          </div>
          <p class="m-0 text-uppercase font-xs mt-2">{{ $t(`backoffice.manage.balance.tables.components.add-value.reason`) }}</p>
          <textarea
            data-cy="reasonSubscrition"
            maxlength="250"
            v-model="reason"
            class="addReduce__input font-xs w-100"
            :placeholder="$t(`backoffice.manage.balance.tables.components.placeholder.reason`)"
          />

          <div>
            <template>
              <CButton
                v-if="item.id"
                data-cy="confirmValueSubscrition"
                color="primary"
                :disabled="Boolean(reason.length) == false || Boolean(currentBalanceTemp) == false"
                @click="updateLineBalance(item)"
              >
                <CIcon name="check" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
              </CButton>
              <CButton
                v-else
                data-cy="confirmValueSubscrition"
                color="primary"
                :disabled="Boolean(reason.length) == false || Boolean(currentBalanceTemp) == false"
                @click="saveLineBalance(item)"
              >
                <CIcon name="check" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
              </CButton>
              <CButton data-cy="cancelValueSubscrition" color="gray-200 ml-1 text-gray-600" @click="toggleInputValue(item, index)">
                <CIcon name="backArrow" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
              </CButton>
            </template>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inputValueSubscription',
  props: {
    actionsButtons: {
      type: Boolean,
      default: () => true,
    },
    actionsToggle: {
      type: Boolean,
      default: () => false,
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isActive: false,
      currentBalanceTemp: null,
      reason: '',
    }
  },

  created() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  methods: {
    addValue() {
      this.isActive = !this.isActive
      this.value = ''
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    closePopUp() {
      this.isActive = false
    },

    addLineBalace() {
      this.$emit('add-country', {
        currentBalanceTemp: Number(this.currentBalanceTemp),
        reason: this.reason,
      })

      this.currentBalanceTemp = ''
      this.reason = ''
      this.isActive = false
    },

    saveLineBalance(item) {
      this.$emit('save-LineBalance', {
        ...item,
        index: this.index,
        balance: Number(this.currentBalanceTemp),
        reason: this.reason,
      })

      this.currentBalanceTemp = ''
      this.reason = ''
    },

    updateLineBalance(item) {
      this.$emit('update-LineBalance', {
        ...item,
        index: this.index,
        balance: Number(this.currentBalanceTemp),
        reason: this.reason,
      })

      this.currentBalanceTemp = ''
      this.reason = ''
    },

    toggleInputValue(item, index) {
      this.$nextTick(() => {
        this.$emit('toggle-inputValue', { item, index })
      })
    },
  },
}
</script>

<style lang="scss">
.inputValueSubscription {
  &__input {
    width: 170px;
    .form-control {
      height: 30px;
    }
  }
}
</style>
